<template lang="pug">
.container-contato
  .form
    .label Envie uma mensagem
    el-form(class="form-custom-nexa" :model="form" ref="formRef" label-width="100px")
      el-form-item(label="Nome")
        el-input(v-model="form.name" placeholder="Seu nome completo" required)
      el-form-item(label="Email")
        el-input(v-model="form.email" placeholder="seu@email.com" type="email" required)
      el-form-item(label="Mensagem")
        el-input(v-model="form.message" resize="none" type="textarea" placeholder="Sua mensagem" required rows="6")
      .enviar-mensagem
        ButtonPadrao(iconLeft)
          LucideIcon(slot="icon-left" name="Send" :size="16")
          | Enviar Mensagem
  .info-contato
    .label Informações de contato
    .info
      .email
        LucideIcon(name="Mail" :size="20" color="#b7ff00")
        div
          .label-info E-mail
          .value contato@exemplo.com
      .telefone
        LucideIcon(name="Phone" :size="20" color="#b7ff00")
        div
          .label-info Telefone
          .value (11) 91234-5678
      .localizacao
        LucideIcon(name="MapPin" :size="20" color="#b7ff00")
        div
          .label-info Localização
          .value Rua Exemplo, 123, São Paulo - SP
    .horario-disponibilidade
      .label-disponibilidade Horário de Disponibilidade
      .datas
        .dia-semana Segunda - Sexta:
        .horario 9:00 - 18:00
      .datas
        .dia-semana Sábado:
        .horario 10:00 - 14:00
      .datas
        .dia-semana Domingo:
        .horario Fechado
    .redes-sociais
      .social
        img(src="@/assets/icons/facebook.svg" alt="Facebook")
      .social
        img(src="@/assets/icons/instagram.svg" alt="Instagram")
      .social
        img(src="@/assets/icons/linkedin.svg" alt="Linkedin")
      .social
        img(src="@/assets/icons/twiter.svg" alt="Twiter")
</template>

<script>
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue';

export default {
  name: 'Contato',

  components: {
    ButtonPadrao,
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          console.log('Formulário enviado:', this.form);
          this.$message.success('Mensagem enviada com sucesso!');
          this.resetForm();
        } else {
          console.error('Erro ao enviar o formulário');
          return false;
        }
      });
    },
    resetForm() {
      this.form.name = '';
      this.form.email = '';
      this.form.message = '';
      this.$refs.formRef.resetFields();
    }
  }
};
</script>

<style lang="scss">
.container-contato{
  display: flex;
  justify-content: space-between;
  width: 100%;

  .form,
  .info-contato{
    width: 100%;
    max-width: 665px;
    padding: 24px;
    box-sizing: border-box;
    background: $corFundoPadraoDashboard;
    border: 1px solid $borderColor;
    border-radius: 8px;

    .label{
      font-size: 20px;
      font-weight: 700;
      color: $corBranco;
      margin-bottom: 24px;
      color: $corVerdeClaro;
    }

    .enviar-mensagem{
      width: 100%;
      margin-top: 20px;

      .botao{
        width: 100%;
      }
    }

    .email,
    .telefone,
    .localizacao{
      display: flex;
      margin-bottom: 16px;

      svg{
        margin-right: 12px;
      }

      .label-info{
        font-size: 16px;
        font-weight: 500;
        color: $corBranco;
        margin-bottom: 5px;
      }
      .value{
        font-size: 16px;
        font-weight: 400;
        color: $corValueInfoContato;
      }
    }
    .localizacao{
      margin-bottom: 0;
    }

    .horario-disponibilidade{
      margin: 24px 0;
      padding-top: 16px;
      border-top: 1px solid $borderColor;

      .label-disponibilidade{
        font-size: 16px;
        font-weight: 500;
        color: $corBranco;
        margin-bottom: 12px;
      }
      .datas{
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;

        .dia-semana,
        .horario{
          font-size: 14px;
          font-weight: 500;
          color: $corValueInfoContato;
        }
      }
    }

    .redes-sociais{
      display: flex;
      justify-content: center;
      gap: 15px;

      .social{
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $corPreto;
        border-radius: 50%;
        cursor: pointer;
        border: 1px solid $borderColor;
        color: $corBranco;

        img{
          width: 16px;
          filter: brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(103%) contrast(103%);
        }

        &:hover{
          background-color: $borderColor;
          border-color: $corVerdeClaro;
          color: $corVerdeClaro;

          img{
            filter: brightness(0) saturate(100%) invert(87%) sepia(97%) saturate(6530%) hue-rotate(18deg) brightness(100%) contrast(105%);
          }
        }
      }
    }
  }
}

// Responsividade para mobile
@media (max-width: 1024px) {
  .container-contato {
    flex-direction: column;
    gap: 24px;

    .form,
    .info-contato {
      max-width: 100%;
      padding: 16px;
      border-top: 1px solid $borderColor;
      border-bottom: none;
    }
  }
}
</style>